<template>
  <div
    v-if="futuresCart.lines && futuresCart.lines.length > 0"
    class="sidecart-content"
  >
    <CartItem
      v-for="(line, index) in futuresCart.lines"
      :key="`cart-item-${line.id}`"
      :line="line"
      :index="index"
      :is-checkout="isCheckout"
      :is-futures="true"
      :toggle-side-cart-on-update="false"
      :toggle-side-cart-on-click="false"
      :show-remove-text="showRemoveText"
      :pdp-link="false"
      :quantity-limit="quantityLimit"
      :futures-cart-item="true"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
export default {
  name: 'FuturesCartContent',
  components: {
    CartItem: defineAsyncComponent(() => import('@/components/Cart/CartItem')),
  },
  props: {
    futuresCart: {
      type: Object,
      required: true,
    },
    showRemoveText: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCheckout: {
      type: Boolean,
      required: false,
      default: true,
    },
    quantityLimit: {
      type: Number,
      default: null,
    },
  },
}
</script>
